import apiClient from './apiClient.js';
import * as utils from '../utils/utils.js';

export const updateEvent = async (
    event_id,
    gathering_id,
    location,
    name,
    short_description,
    long_description,
    is_single_event,
    weekday,
    time,
    single_date,
    min_participants,
    max_participants,
    owner_id,
    notifications,
    notificationType,
    allowGuests
    //active,
) => {
    const session_url = '/event';
    if (single_date === undefined) {
        single_date = null;
    }
    if (weekday === undefined) {
        weekday = 0;
    }
    try {
        const response = await apiClient.patch(session_url, {
            event_id: event_id,
            owner_id: owner_id,
            gathering_id: gathering_id,
            name: name,
            short_description: short_description,
            long_description: long_description,
            type: is_single_event ? utils.SINGLE_EVENT : utils.REPEATING_EVENT,
            weekday: is_single_event ? undefined : weekday,
            time_of_day: is_single_event ? undefined : time.format('HH:mm'),
            single_date: is_single_event ? single_date : undefined,
            active: '1',
            venue_id: location,
            min_participants: min_participants,
            max_participants: max_participants,
            notifications: notifications,
            notificationType: notificationType,
            allow_guests: allowGuests,
        });
        return response.data;
    } catch (err) {
        console.log(err.message);
        console.log(err.response);
        throw err;
    }
};
